// extracted by mini-css-extract-plugin
export var colorBase = "k6UDHgs55dq0VfQeip7o";
export var colorDisabled = "JbIEaCL_YP8DaR9gKy3z";
export var colorInverted = "XIegSxuK5zxvzgvUg9IY";
export var colorNegative = "J53j09bTHiiM8AgdCCsA";
export var colorPositive = "d6us8wE6lE4WDI73XQPu";
export var colorSubdued = "ftAu7QHRFirwdLAvFs4P";
export var colorSubtle = "juA5JSDSLS_2TPGAgdNP";
export var colorUrgencyHigh = "hBoyG0iTULlouXQyDWwA";
export var colorUrgencyMedium = "YiQQW7vrDkAvX2QnSl8O";
export var colorWarning = "_5Z129JUXsGVGy3vJcavj";
export var colorWhite = "a2os8rp78s7FdeN4dmhM";